import type { FC } from 'react';
import { Trans } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import CalendarIcon from '@wix/da-ds/pkg/Icons/Calendar';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { DATE_FORMATS, formatDate } from '@wix/da-ds/pkg/Time/functions';

import s from './PlanExpiringNote.scss';

interface Props {
  endTimestamp: string | number;
}

const PlanExpiringNote: FC<Props> = ({ endTimestamp }) => {
  return (
    <Heading className={s['root']}>
      {/* prettier-ignore */}
      <Trans i18nKey={'packagePicker.heroTable.header.expiring'}>
          Your Core plan is expiring on{' '}
          <span className={s['end-date']}>
            {formatDate(endTimestamp, DATE_FORMATS.Date.Short)}
          </span>
        </Trans>
      <CalendarIcon size={IconSize.SMALLER} className={s['calendar-icon']} />
    </Heading>
  );
};
PlanExpiringNote.displayName = 'PlanExpiringNote';

export default PlanExpiringNote;
